import { Fragment } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { StatisticsProps } from './types'

export const StatisticsColumn = ({ items, className }: StatisticsProps) => {
  const visibleItems = items.filter(({ hide }) => !hide)

  return (
    <div
      className={cn(
        'grid grid-cols-[max-content,minmax(0,1fr)] items-center gap-x-8 gap-y-2',
        className,
      )}
    >
      {visibleItems.map(({ title, icon, children }, index) => (
        <Fragment key={`${title}-${index}`}>
          <div className='flex min-h-8 items-center gap-1 whitespace-nowrap'>
            {icon}
            <h3 className='text-main-foreground-secondary text-body-small'>{title}</h3>
          </div>
          <div className='min-w-0'>{children}</div>
        </Fragment>
      ))}
    </div>
  )
}
